import Axios from "axios";
import qs from "qs";
import sha1 from "sha1";

let secret = process.env.CLIENT_SECRET;
let clientId = process.env.CLIENT_ID;

// 创建签名
let createSign = (payload) => {
  let payloadStr = "";
  Object.keys(payload).forEach((feild) => {
    payloadStr += `${feild}${payload[feild]}`;
  });
  return sha1(`${secret}${payloadStr}${secret}`);
};

const request = Axios.create({
  baseURL: process.env.API_HOST,
  headers: {
    "Content-Type": "application/x-www-form-urlencoded",
  },
});

request.interceptors.request.use((config) => {
  if (
    config.method === "post" &&
    config.headers["Content-Type"] !== "application/json" &&
    config.data
  ) {
    config.data = qs.stringify(config.data);
  }
  return config;
});

// 响应拦截器
request.interceptors.response.use(
  (res) => {
    console.log(res)
    console.log(res.data)
    console.log(res.data.data)
    const { returncode, returnmsg } = res.data.data;
    if (returncode === "0000") {
      return res.data.data;
    } else {
      return Promise.reject(returnmsg);
    }
  },
  (error) => {
    console.log(123456789)
    console.log(error)
    return Promise.reject(error);
  }
);

// 体验券及权益券
export function doFreeTrial(payload) {
  return request.post(
    "/v5/qy/experience_voucher_redemption",
    payload, {
    headers: {
      "Content-Type": "application/json",
    }
  }
  );
}

// 兑换券权益
export function docoupon(payload) {
  return request.post("/v5/qy/coupon_redemption", payload, {
    headers: {
      "Content-Type": "application/json",
    }
  });
}

// 获取验证码
export const getVerityCode = (params) => {
  let payload = {
    login_name: params.phoneNumber,
    type: "0",
    source: "yc_magazine_ofl",
  };

  let mypayload = params;
  let sign = createSign(payload);
  mypayload["client_id"] = clientId;
  mypayload["source"] = "yc_magazine_ofl";
  mypayload["sign"] = sign;
  return request.post("/v5/yicai_users/new_users_sms", mypayload, {
    headers: {
      "Content-Type": "application/json",
    }
  });
};



// WEBPACK FOOTER //
// ./src/api/channel.js